import * as en from './en'
import * as hu from './hu'
export default {en, hu}
